import { render, staticRenderFns } from "./video-widget.vue?vue&type=template&id=404d4f44"
import script from "./video-widget.vue?vue&type=script&lang=js"
export * from "./video-widget.vue?vue&type=script&lang=js"
import style0 from "./video-widget.vue?vue&type=style&index=0&id=404d4f44&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports